import { UPDATE_TICKET_ASSIGN, UPDATE_TICKET_ASSIGN_SUCCESS, UPDATE_TICKET_ASSIGN_ERROR, UPDATE_TICKET_ASSIGN_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateTicketAssign = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_TICKET_ASSIGN:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_TICKET_ASSIGN_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_TICKET_ASSIGN_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_TICKET_ASSIGN_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateTicketAssign;
